/**
 * These are the benefits that are available and client-side sends to the backend as suggested benefits.
 * the final decision is made on the backend. The backend will check if the user is eligible for these
 * benefits and return them.
 *
 * All benefits: EA_ACTIVE, EX_ACTIVE, EA_ELIGIBLE, EX_ElIGIBLE
 */
export var makeRequestedLoyaltyAccessParam = function (isLoyaltyMarker, isABTestRunning) {
    if (isLoyaltyMarker) {
        return 'EA_ACTIVE, EX_ACTIVE, EA_ELIGIBLE';
    }
    return null;
};
